module.exports = __webpack_public_path__ + "img/logo-icon-white.2e7e8e46.png";